import CarrotPlanIsOnTheWayBanner from "#/components/home/carrot-plan/CarrotPlanOnTheWayBanner"
import { GoalsIllustration, Stack, Tile, useTheme } from "@carrotfertility/carotene-core"
import React from "react"
import { useFlags } from "launchdarkly-react-client-sdk"
import { AirwallexKycHero } from "#/components/home/AirwallexKycHero"
import { BenefitHighlights } from "#/components/home/benefits-modules/BenefitHighlights"

export const Hero = ({ carrotPlanIsOnTheWay }: { carrotPlanIsOnTheWay: boolean }): JSX.Element => {
  const theme = useTheme()
  const { airwallexBenefitChampion } = useFlags()

  return (
    <Tile
      id="homepage-info-tile"
      variant="primary"
      slotProps={{
        illustrationContainer: {
          sx: {
            insetBlockStart: theme.spacing(theme.tokens.spacing.lg),
            display: { xs: "block", sm: "block", md: "block" },
            "> *": {
              blockSize: "100%",
              inlineSize: "auto",
              transform: { xs: "translateX(50%)", sm: "translateX(50%)", md: "none", lg: "none" }
            }
          }
        }
      }}
      illustration={carrotPlanIsOnTheWay ? null : <GoalsIllustration />}
    >
      <Stack spacing={theme.spacing(theme.tokens.spacing.lg)}>
        {airwallexBenefitChampion ? (
          <AirwallexKycHero />
        ) : (
          <>
            {carrotPlanIsOnTheWay && <CarrotPlanIsOnTheWayBanner />}
            <BenefitHighlights />
          </>
        )}
      </Stack>
    </Tile>
  )
}
